import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Clinic } from 'src/app/layouts/private-layout/pages/clinic/services/clinic.model';
import { ApiService } from 'src/app/services/api.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  UserDetails!: any;
  ListClinics: Clinic[] = [];
  SelectedClinic: number | null;
  IsLoading: boolean = false;
  constructor(private sharedService: SharedService, public apiService: ApiService) {
    this.IsLoading = true;
    this.apiService.GetClinics();
    this.sharedService.UserDetails.subscribe((value) => {
      this.UserDetails = value;
    });
    this.ListClinics = this.apiService.ClinicList.value;
    this.apiService.ClinicList.subscribe((list) => (this.ListClinics = list));

    if (this.sharedService.getData('currentClinic')) {
      this.SelectedClinic = Number(this.sharedService.getData('currentClinic'));
      this.sharedService.changeClinicId(this.SelectedClinic || 0);
    } else {
      this.SelectedClinic = this.sharedService.IsAdminUser.value ? 0 : this.sharedService.CurrentClinic.value;
    }
  }

  ngOnInit(): void {
    this.IsLoading = false;
  }

  ToggleSidebar() {
    document.body.classList.toggle('toggle-sidebar');
  }

  ChangeClinic() {
    this.sharedService.changeClinicId(this.SelectedClinic || 0);
    this.sharedService.setData('currentClinic', Number(this.SelectedClinic));
  }

  SignOut() {
    this.sharedService.setUserLoggedIn(false);
  }
}
